<p>
  create-dealer works!
</p>
